module.exports = __webpack_public_path__ + "img/redBalloneHalfVertical.76a5c6ec.png";